export enum AMPLITUDE_EVENTS {
  USER_LOGIN = 'user_login',
  USER_LOGOUT = 'user_logout',
  SWITCH_BUSINESS = 'switch_business',
  PAGE_VIEW = 'page_view',
  APPLICATION_STATUS_CHANGE = 'application_status_change',
}

export interface AMPLITUDE_EVENT_PROPERTIES_MAP {
  [AMPLITUDE_EVENTS.USER_LOGIN]: undefined;
  [AMPLITUDE_EVENTS.USER_LOGOUT]: undefined;
  [AMPLITUDE_EVENTS.SWITCH_BUSINESS]: undefined;
  [AMPLITUDE_EVENTS.PAGE_VIEW]: {
    page_name: string;
    page_path: string;
  };
  [AMPLITUDE_EVENTS.APPLICATION_STATUS_CHANGE]: {
    business_id: string;
    new_status: string;
  };
}

export type AMPLITUDE_EVENT_PROPERTIES<T extends AMPLITUDE_EVENTS> =
  AMPLITUDE_EVENT_PROPERTIES_MAP[T];

export interface AMPLITUDE_USER_PROPERTIES {
  role?: string;
  email?: string;
  last_login?: string;

  business_id?: string;
  business_syncetera_id?: string;
  application_status?: string;
  business_name?: string;
  dba_name?: string;
}
